import {
  put, takeEvery, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import AddToCartActions, { addToCartActionTypes } from '../../actions/addToCart/addToCartActions';
import AddToCartServices from '../../services/addToCart/addToCart.services';

function* _addToCart(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AddToCartActions.addToCartLoadingV2(true));
    const cartResponse = yield AddToCartServices.addToCartV2(payload);
    if (cartResponse?.success) {
      // notification.open({
      //   type: 'success',
      //   message: 'Products added to cart successfully.',
      //   duration: 4,
      //   placement: 'top',
      // });

      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: cartResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AddToCartActions.addToCartLoadingV2(false));
  } catch (error) {
    yield put(AddToCartActions.addToCartLoadingV2(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* addToCart() {
  yield takeEvery(addToCartActionTypes.NEW_ADD_TO_CART.REQUEST, _addToCart);
}

function* _getCartV2(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AddToCartActions.getCartV2Loading(true));
    const cartResponse = yield AddToCartServices.getCartV2(payload);
    if (cartResponse?.success) {
      yield put(AddToCartActions.getCartV2Success(cartResponse));
      if (callback) {
        callback(cartResponse);
      }
    } else {
      notification.open({
        type: 'error',
        message: cartResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AddToCartActions.getCartV2Loading(false));
  } catch (error) {
    yield put(AddToCartActions.getCartV2Loading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getCartV2() {
  yield takeEvery(addToCartActionTypes.NEW_GET_CART.REQUEST, _getCartV2);
}

function* _removeFromCartV2(action) {
  try {
    const {
      payload, callback,
    } = action;
    yield put(AddToCartActions.removeFromCartV2Loading(true));
    const cartResponse = yield AddToCartServices.removeFromCartV2(payload);
    if (cartResponse?.success) {
      // notification.open({
      //   type: 'success',
      //   message: 'items successfully removed from the cart ',
      //   duration: 4,
      //   placement: 'top',
      // });

      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: cartResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AddToCartActions.removeFromCartV2Loading(false));
  } catch (error) {
    yield put(AddToCartActions.removeFromCartV2Loading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* removeFromCartV2() {
  yield takeEvery(addToCartActionTypes.NEW_REMOVE_FROM_CART.REQUEST, _removeFromCartV2);
}

export default function* addToCartSaga() {
  yield all([
    addToCart(),
    getCartV2(),
    removeFromCartV2(),
  ]);
}
